@use '~/theme/theme' as *;
@use '~/theme/typography';

.field {
  display: flex;
  flex-direction: column;
  gap: spacing(1);

  --label-color: #{color(grey-800)};
  --description-color: #{color(grey-600)};

  [slot='description'] {
    @include typography.caption;
    @include typography.medium;

    color: var(--description-color);
  }

  [slot='errorMessage'] {
    @include typography.caption;
    @include typography.medium;

    color: color(lobster-900);
  }

  &[data-disabled] {
    --description-color: #{color(grey-500)};
    --label-color: #{color(grey-800)};
  }

  &[data-size='small'] {
    gap: spacing(0.5);

    :global {
      /* stylelint-disable-next-line selector-class-pattern */
      .react-aria-Label {
        @include typography.caption;
        @include typography.semibold;
      }
    }
  }

  &[data-size='medium'] {
    gap: spacing(0.5);

    :global {
      /* stylelint-disable-next-line selector-class-pattern */
      .react-aria-Label {
        @include typography.caption;
        @include typography.semibold;
      }
    }
  }

  &[data-size='large'] {
    :global {
      /* stylelint-disable-next-line selector-class-pattern */
      .react-aria-Label {
        @include typography.body2;
        @include typography.semibold;
      }
    }
  }

  :global {
    /* stylelint-disable-next-line selector-class-pattern */
    .react-aria-Label {
      align-self: stretch;
      color: var(--label-color);
      letter-spacing: 0.2px;
      text-align: left;
    }
  }
}
